import { render, staticRenderFns } from "./create360EvaluationQuestion.vue?vue&type=template&id=dbf3c2c4&scoped=true"
import script from "./create360EvaluationQuestion.vue?vue&type=script&lang=js"
export * from "./create360EvaluationQuestion.vue?vue&type=script&lang=js"
import style0 from "./create360EvaluationQuestion.vue?vue&type=style&index=0&id=dbf3c2c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf3c2c4",
  null
  
)

export default component.exports